import type { TBlueObj } from "@app/types/insider";
import { EMenuCmdTab } from "@app/state/constants";

//this will imitate the Delphi Buttons in the header;
// we need to set those buttons imperatively, even if we are in the browser
// as we intend to use the same code for the delphi app

type TUiJgBrowserHeader = {
  tabsAvailable: EMenuCmdTab[];
  tabSelected: EMenuCmdTab | null;
};

export const uiJGBrowserHeader: TBlueObj<TUiJgBrowserHeader> = {
  name: "uiJGBrowserHeader",
  initialState: {
    tabsAvailable: [] as EMenuCmdTab[],
    tabSelected: null as EMenuCmdTab | null,
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};
